import styled from 'styled-components';

export const StyledPointsValue = styled.span`
  cursor: pointer;
`;

export const StyledRadioLabel = styled.label`
  margin-right: 5px;
`;

export const StyledRadio = styled.input`
  margin-right: 2px;
  margin-top: 5px;
`;
export const ErrorCode = styled.span`
  color: red;
`;
export const ErrorCodeContainer = styled.div`
  white-space: pre-wrap;
  margin-bottom: 12px;
`;
